import React from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import styles from './index.module.scss.js';

const ToastContent = ({
  title,
  description,
  link
}) => /* @__PURE__ */ React.createElement("div", { className: cx(styles.box) }, title && /* @__PURE__ */ React.createElement("p", { className: cx(styles.title) }, title), description && /* @__PURE__ */ React.createElement("p", { className: cx(styles.description) }, description), link && /* @__PURE__ */ React.createElement(Link, { className: cx(styles.link), to: link?.href }, link?.title));
ToastContent.displayName = "ToastContent";

export { ToastContent };
//# sourceMappingURL=index.js.map
